var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }